import Permission from "@/common/components/auth/Permission";
import IventoryCard from "@/common/helpers/inventory-card";
import { FaMotorcycle, FaFile } from "react-icons/fa";
import { GrHostMaintenance, GrMapLocation } from "react-icons/gr";
import { useNavigate } from "react-router-dom";

export const AuditsMenu = () => {
  const navigate = useNavigate();

  return (
    <section className="w-full p-6">
      <header className="w-full pb-4 mb-6 border-b border-gray-200">
        <h2 className="text-3xl font-bold text-gray-800 tracking-tight">
          📦 Módulo de Auditoria{" "}
        </h2>
      </header>

      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-6">
        <Permission permission="view:categories">
          <div
            onClick={() => navigate("/audits/vehicles-maintenance")}
            className="hover:cursor-pointer"
          >
            <IventoryCard
              icon={<FaMotorcycle />}
              iconSize="70px"
              title="Atraso de Manutenções"
              legend="Verificar veículos com manutenções atrasadas ou pendentes."
              iconClassName="text-locavibe"
              className="transition-all duration-300 hover:shadow-xl hover:scale-[1.02] rounded-2xl"
            />
            <span className="text-gray-500 mt-2 block text-center"></span>
          </div>
        </Permission>

        <Permission permission="view:products">
          <div
            onClick={() => navigate("/audits/vehicle-trackers")}
            className="hover:cursor-pointer"
          >
            <IventoryCard
              icon={<GrMapLocation />}
              iconSize="70px"
              title="Rastreadores"
              legend="Verificar última comunicação dos rastreadores veiculares."
              iconClassName="text-locavibe"
              className="transition-all duration-300 hover:shadow-xl hover:scale-[1.02] rounded-2xl"
            />
          </div>
        </Permission>
        <Permission permission="view:products">
          <div
            onClick={() => navigate("/audits/vehicle-ipva")}
            className="hover:cursor-pointer"
          >
            <IventoryCard
              icon={<FaFile />}
              iconSize="70px"
              title="IPVA"
              legend="Verificar veículos com IPVA vencido ou próximo do vencimento."
              iconClassName="text-locavibe"
              className="transition-all duration-300 hover:shadow-xl hover:scale-[1.02] rounded-2xl"
            />
          </div>
        </Permission>
        <Permission permission="view:reports-commissions">
          <div
            onClick={() => navigate("/relatorios/MaintenanceCompleted")}
            className="hover:cursor-pointer"
          >
            <IventoryCard
              icon={<GrHostMaintenance />}
              iconSize="70px"
              title="Manutenções "
              legend="Verificar manutenções finalizadas."
              iconClassName="text-locavibe"
              className="transition-all duration-300 hover:shadow-xl hover:scale-[1.02] rounded-2xl"
            />
          </div>
        </Permission>
      </div>
    </section>
  );
};
